import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import MouseGlow from '../ui/MouseGlow';
import FormulaireConnexion, { EcranRedirection } from './FormulaireConnexion';
import heroIllustration from '../../assets/hero-illustration-pictos.png';
import { useTranslation } from '../../context/LanguageContext';

// Check if registration is disabled via environment variable
const isRegistrationDisabled = import.meta.env.VITE_DISABLE_REGISTRATION === 'true';

const LandingPage = ({ onLogin }) => {
    const { t } = useTranslation();

    // LE FORMULAIRE VIT DANS FormulaireConnexion, partage avec le bloc
    // « accueilConnexion » de la page d'accueil servie depuis la base. La
    // page garde l'ecran de redirection : il remplace la page ENTIERE,
    // en-tete et pied de page compris, ce que le formulaire ne peut pas
    // faire depuis sa place. Il la previent, elle pose l'ecran.
    const [isRedirecting, setIsRedirecting] = useState(false);

    if (isRedirecting) {
        return <EcranRedirection />;
    }

    return (
        <div className="min-h-screen bg-white relative">
            <MouseGlow />
            <Header onLogin={onLogin} />

            <main>
                {/* Hero Section */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                        {/* Left Content - Login Form */}
                        <div className="space-y-6 animate-fade-in-up">
                            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
                                <span className="block text-cabaza-purple">{t.landing?.title1 || 'Connect'}</span>
                                <span className="block">{t.landing?.title2 || 'simply'}</span>
                            </h1>

                            {/* Slogan */}
                            <p className="text-xl md:text-2xl font-semibold bg-gradient-to-r from-cabaza-purple to-cabaza-pink bg-clip-text text-transparent">
                                {t.landing?.slogan || 'Le réseau social européen pour échanger'}
                            </p>

                            {/* Description */}
                            <p className="text-base text-gray-600">
                                {t.landing?.description || 'Cabaza réunit les européens qui veulent partager leurs compétences, services et passions. Rejoignez une communauté où chaque échange crée de nouvelles opportunités.'}
                            </p>

                            {!isRegistrationDisabled && (
                                <p className="text-lg text-gray-600">
                                    {t.landing?.subtitle || 'Manage your contacts and business cards with ease and start offering or requesting services.'}
                                </p>
                            )}

                            {/* Login Form — partage avec le bloc « accueilConnexion » */}
                            <FormulaireConnexion onRedirection={() => setIsRedirecting(true)} />
                        </div>

                        {/* Right Content - Illustration */}
                        <div className="relative animate-fade-in hidden md:block">
                            <div className="absolute inset-0 bg-gradient-to-tr from-purple-100 to-pink-100 rounded-full filter blur-3xl opacity-30 transform scale-110"></div>
                            <img
                                src={heroIllustration}
                                alt="Professionals connecting"
                                className="relative z-10 w-full h-auto hover:scale-105 transition-transform duration-500"
                            />
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default LandingPage;
